import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data';
import { Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-50 pt-24 pb-12 border-t border-stone-200">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          
          {/* Brand Column */}
          <div className="md:col-span-5">
            <Link to="/" className="flex flex-col mb-8">
              <span className="text-2xl font-light tracking-widest text-stone-900 uppercase">
                Massageterapi <span className="font-serif italic lowercase tracking-normal">CPH</span>
              </span>
            </Link>
            <p className="text-stone-600 font-light leading-relaxed max-w-sm mb-10 text-lg">
              Professionel behandling med fokus på sammenhængen mellem krop og sind. Registreret Alternativ Behandler (RAB).
            </p>
            <div className="flex items-center space-x-8">
              <img 
                src="/kundebilleder/alternativ_behandler.webp" 
                alt="Registreret Alternativ Behandler (RAB)" 
                className="h-16 w-auto grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition-all duration-500"
              />
              <div className="h-12 w-[1px] bg-stone-200"></div>
              <div className="flex flex-col">
                <span className="text-[10px] uppercase tracking-widest text-stone-400 mb-1">Certificeret</span>
                <span className="text-sm text-stone-600">RAB Behandler</span>
              </div>
            </div>
          </div>

          {/* Spacer */}
          <div className="hidden md:block md:col-span-1"></div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-[10px] uppercase tracking-[0.3em] text-stone-400 font-bold mb-8">Menu</h4>
            <ul className="space-y-5">
              {[
                { name: 'Forside', path: '/' },
                { name: 'Behandling', path: '/behandling/integrativ-massageterapi' },
                { name: 'Om Trine', path: '/om-trine' },
                { name: 'Praktisk info', path: '/praktisk' },
                { name: 'Kontakt', path: '/kontakt' },
              ].map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-stone-600 hover:text-stone-900 transition-colors font-light tracking-wide uppercase"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Socials & Contact */}
          <div className="md:col-span-3">
            <h4 className="text-[10px] uppercase tracking-[0.3em] text-stone-400 font-bold mb-8">Kontakt & Social</h4>
            <div className="space-y-6">
              <p className="text-sm text-stone-600 font-light leading-relaxed">
                {siteConfig.address}
              </p>
              <div className="space-y-2">
                <p className="text-sm text-stone-600 font-light">
                  <a href={`mailto:${siteConfig.email}`} className="hover:text-stone-900 transition-colors border-b border-transparent hover:border-stone-900">
                    {siteConfig.email}
                  </a>
                </p>
                <p className="text-sm text-stone-600 font-light">
                  <a href={`tel:${siteConfig.phone.replace(/\s/g, '')}`} className="hover:text-stone-900 transition-colors border-b border-transparent hover:border-stone-900">
                    {siteConfig.phone}
                  </a>
                </p>
              </div>
              <div className="flex space-x-6 pt-4">
                <a href={siteConfig.socials.instagram} className="text-stone-400 hover:text-stone-900 transition-all transform hover:-translate-y-1">
                  <Instagram size={20} />
                </a>
                <a href={siteConfig.socials.facebook} className="text-stone-400 hover:text-stone-900 transition-all transform hover:-translate-y-1">
                  <Facebook size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-stone-200 flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          <p className="text-[10px] uppercase tracking-widest text-stone-400">
            &copy; {currentYear} Massageterapi CPH.
          </p>
          <div className="flex items-center space-x-8">
            <span className="text-[10px] uppercase tracking-widest text-stone-400 font-medium">CVR: 42081833</span>
            <Link to="/privatlivspolitik" className="text-[10px] uppercase tracking-widest text-stone-400 hover:text-stone-900 transition-colors font-medium underline underline-offset-4">
              Privatlivspolitik
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
